export const heading = {
    en:"Provide your basic information.",
    hi:"अपनी मुख्य जानकारी भरें।",
    or: "ଆପଣଙ୍କର ମୌଳିକ ସୂଚନା ପ୍ରଦାନ କରନ୍ତୁ"
  }
export const secondaryHeading = {
    en:"Please fill in all the details.",
    hi:"कृपया सभी विवरण भरें",
    or: "ଦୟାକରି ସମସ୍ତ ବିବରଣୀ ପୂରଣ କରନ୍ତୁ"
  }

  export const form_headings = {
    name: { en: "Name", hi: "नाम", or: "ନାମ" },
    age: { en: "Age", hi: "उम्र", or: "ବୟସ" },
    mobile: { en: "Mobile no.", hi: "मोबाइल नंबर", or: "ଫୋନ୍ ନମ୍ବର" },
    block: { en: "Block", hi: "ब्लॉक", or: "ବ୍ଲକ୍" },
    district: { en: "District", hi: "डिस्ट्रिक्ट", or: "ଜିଲ୍ଲା" },
    subcenter: { en: "Subcenter", hi: "सबसेंटर", or: "ସବସେଣ୍ଟର୍" },
    proceed: {
        en: "Fill the details to proceed",
        hi: "आगे  बढ़ने  के  लिए  सारी  जानकारी  भरें",
        or: "ଆଗକୁ ବଢ଼ିବା ପାଇଁ ଦୟାକରି ସମସ୍ତ ସୂଚନା ପ୍ରଦାନ କରନ୍ତୁ"
    },
    fill: {
        en: "Proceed",
        hi: "आगे बढ़े",
        or: "ଅଗ୍ରସର"
    },
};

export const formAudio = {
  en: "Provide your basic information by filling in all the details. Then click on proceed to go forward.",
  hi: "कृपया अपनी मुख्य जानकारी भरें। फिर आगे बढ़ने के लिए 'आगे बढ़ें' पर क्लिक करें।",
  or: "ସମସ୍ତ ବିବରଣୀ ପୂରଣ କରି ଆପଣଙ୍କର ମୌଳିକ ବିବରଣୀ ପ୍ରଦାନ କରନ୍ତୁ। ତା'ପରେ ଆଗକୁ ଯିବା ପାଇଁ 'ଅଗ୍ରସର' ଉପରେ କ୍ଲିକ୍ କରନ୍ତୁ।"
};

